/* ============================================================
   HQ About page - hqx-about.js
   Optional horizontal slider for the card sections. Progressive
   enhancement: the track scrolls and swipes with no JS at all;
   this only adds prev/next arrow behaviour and end-state disabling.
   Loaded only by sections whose layout is set to "Slider".
   ============================================================ */
(function () {
  'use strict';
  if (window.__hqxAboutLoaded) { return; }
  window.__hqxAboutLoaded = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initCarousel(root) {
    if (!root || root.dataset.hqInit) { return; }
    root.dataset.hqInit = '1';
    var track = root.querySelector('[data-about-track]');
    var prev = root.querySelector('[data-about-prev]');
    var next = root.querySelector('[data-about-next]');
    if (!track) { return; }

    function step() {
      var card = track.firstElementChild;
      if (!card) { return 280; }
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 18;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) { prev.disabled = track.scrollLeft <= 4; }
      if (next) { next.disabled = track.scrollLeft >= max - 4; }
    }

    if (prev) { prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); }); }
    if (next) { next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); }); }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---- stats count-up: animate the numbers when they scroll into view.
     Parses each number, keeps any prefix/suffix (commas, +, stars, "Days"),
     eases 0 -> target. Skipped under reduced-motion (final value stays). ---- */
  function animateNum(el) {
    if (el.dataset.hqCounted) { return; }
    el.dataset.hqCounted = '1';
    var raw = (el.textContent || '').trim();
    var m = raw.match(/[\d.,]+/);
    if (!m) { return; }
    var numStr = m[0].replace(/,/g, '');
    var target = parseFloat(numStr);
    if (isNaN(target)) { return; }
    var prefix = raw.slice(0, m.index);
    var suffix = raw.slice(m.index + m[0].length);
    var decimals = numStr.indexOf('.') !== -1 ? numStr.split('.')[1].length : 0;
    function fmt(v) {
      var n = decimals ? v.toFixed(decimals) : Math.round(v).toLocaleString('en-US');
      return prefix + n + suffix;
    }
    var dur = 1600, startTs = null;
    function frame(ts) {
      if (startTs === null) { startTs = ts; }
      var p = Math.min((ts - startTs) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) { requestAnimationFrame(frame); } else { el.textContent = fmt(target); }
    }
    el.textContent = fmt(0);
    requestAnimationFrame(frame);
  }

  function initCountUp() {
    var groups = document.querySelectorAll('[data-about-countup]');
    if (!groups.length || reduce || !('IntersectionObserver' in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('.about-stat__num').forEach(animateNum);
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    groups.forEach(function (g) { io.observe(g); });
  }

  /* ---- auto-rotating slider (hero icon points on phones) ----
     Advances one item every N ms and loops. Only acts when the element is a
     scrollable rail (phones); on desktop it's a grid (nothing to scroll).
     Stops for good once the visitor swipes, and pauses on a hidden tab. ---- */
  function initAutoSlider() {
    if (reduce) { return; }
    document.querySelectorAll('[data-about-autoslider]').forEach(function (track) {
      if (track.dataset.hqAuto) { return; }
      track.dataset.hqAuto = '1';
      var interval = parseInt(track.getAttribute('data-about-autoslider'), 10) || 4000;
      var stopped = false;
      track.addEventListener('pointerdown', function () { stopped = true; }, { passive: true });
      setInterval(function () {
        if (stopped || document.hidden) { return; }
        var max = track.scrollWidth - track.clientWidth;
        if (max < 6) { return; }
        var first = track.firstElementChild;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        var step = first ? first.getBoundingClientRect().width + gap : track.clientWidth;
        var next = track.scrollLeft + step;
        if (next > max - 6) { next = 0; }
        track.scrollTo({ left: next, behavior: 'smooth' });
      }, interval);
    });
  }

  /* ---- scroll reveal: fade up the below-the-fold blocks as they enter view.
     Targets sit off-screen at load so adding the hidden state causes no flash;
     the hero (above the fold) is intentionally not revealed. ---- */
  function initReveal() {
    if (reduce || !('IntersectionObserver' in window)) { return; }
    /* In the theme editor there's no real scrolling to trigger reveals, so show
       everything immediately - merchants must see every section while editing. */
    if (window.Shopify && window.Shopify.designMode) { return; }
    var els = document.querySelectorAll('.about-story__media,.about-story__content,.about-head,.about-cards,.about-who__sub,.about-stats,.about-net,.about-carousel,.about-store__main,.about-store__mapcol,.about-cta');
    if (!els.length) { return; }
    document.documentElement.classList.add('hqx-reveal-on');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function init() {
    document.querySelectorAll('[data-about-carousel]').forEach(initCarousel);
    initCountUp();
    initAutoSlider();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
